const BADGE_COLORS = {
  DEFAULT: "default",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
} as const

export type BadgeColor = (typeof BADGE_COLORS)[keyof typeof BADGE_COLORS]

export { BADGE_COLORS as badgeColors }
